import { render, staticRenderFns } from "./orderInvoice.vue?vue&type=template&id=0cccbf63&scoped=true&"
import script from "./orderInvoice.vue?vue&type=script&lang=js&"
export * from "./orderInvoice.vue?vue&type=script&lang=js&"
import style0 from "./orderInvoice.vue?vue&type=style&index=0&id=0cccbf63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cccbf63",
  null
  
)

export default component.exports